import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';
import { Gradient } from './Gradient.js';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  scrollEffect();
  gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

  // サイドナビの高さを動的に設定
  setSideNavHeight();
});

/*-------------------------------------------------------------------------------
  サイドナビの高さを動的に設定（CMSで項目数が変動する場合に対応）
--------------------------------------------------------------------------------*/
function setSideNavHeight() {
  const sideNav = document.querySelector('.cmn-side-nav');
  if (!sideNav) return;

  // モバイル表示時（768px以下）は高さを設定しない（折りたたみ機能と競合するため）
  if (window.innerWidth <= 768) {
    sideNav.style.height = '';
    return;
  }

  // 全てのli要素の高さを合計
  const listItems = sideNav.querySelectorAll('li');
  let totalHeight = 0;

  listItems.forEach((li, index) => {
    // li自体の高さ
    totalHeight += li.offsetHeight;

    // 2番目以降のliにはmargin-topが付与されているので、それも含める
    if (index > 0) {
      const marginTop = parseFloat(getComputedStyle(li).marginTop);
      totalHeight += marginTop;
    }
  });

  // is-recruit-navの場合はpaddingも含める
  if (sideNav.classList.contains('is-recruit-nav')) {
    const styles = getComputedStyle(sideNav);
    const paddingTop = parseFloat(styles.paddingTop);
    const paddingBottom = parseFloat(styles.paddingBottom);
    totalHeight += paddingTop + paddingBottom;
  }

  // ulにheightを設定
  if (totalHeight > 0) {
    sideNav.style.height = `${totalHeight}px`;
  }
}

// ウィンドウリサイズ時にも再計算（レスポンシブ対応）
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    setSideNavHeight();
  }, 250);
});


/*-------------------------------------------------------------------------------
  header nav current page
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const hdNav = document.querySelector('.hd-nav:not(.is-recruit-hd-nav)');
  if (!hdNav) return;

  const navButtons = hdNav.querySelectorAll('li .hd-nav-btn');
  const body = document.body;

  // ページごとの対応表（0-indexed）
  const pageMap = {
    0: ['home', 'page-template-front-page'], // 1番目のli（index）
    2: ['department', 'convalescent', 'single-division', 'single-medical'], // 3番目のli
    3: ['about', 'record'], // 4番目のli
    4: ['hospitalization'], // 5番目のli
    5: ['single-news', 'post-type-archive-news', 'tax-news_tax'] // 6番目のli（news single含む）
  };

  // 現在のページに該当するインデックスを探す
  for (const [index, classes] of Object.entries(pageMap)) {
    if (classes.some(cls => body.classList.contains(cls))) {
      const targetBtn = navButtons[parseInt(index)];
      if (targetBtn) {
        targetBtn.classList.add('is-current');
      }
      break;
    }
  }
});

/*-------------------------------------------------------------------------------
  recruit header nav current page
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const recruitHdNav = document.querySelector('.hd-nav.is-recruit-hd-nav');
  if (!recruitHdNav) return;

  const navButtons = recruitHdNav.querySelectorAll('li .hd-nav-btn');
  const body = document.body;

  // リクルートページごとの対応表（0-indexed）
  const recruitPageMap = {
    0: ['recruit'], // 1番目のli（recruit）
    1: ['nursing-recruit'], // 2番目のli（nursing-recruit）
    2: ['rehabilitation-recruit'], // 3番目のli（rehabilitation-recruit）
    3: ['requirements', 'single-requirements'] // 4番目のli（requirements、singleページ含む）
  };

  // 現在のページに該当するインデックスを探す
  for (const [index, classes] of Object.entries(recruitPageMap)) {
    if (classes.some(cls => body.classList.contains(cls))) {
      const targetBtn = navButtons[parseInt(index)];
      if (targetBtn) {
        targetBtn.classList.add('is-current');
      }
      break;
    }
  }
});

/*-------------------------------------------------------------------------------
  pc global nav
--------------------------------------------------------------------------------*/
const mq = window.matchMedia('(min-width: 951px)');

function setupHoverMenu() {
  document.querySelectorAll('.is-pulldown-btn').forEach(button => {
    const subMenu = button.nextElementSibling;

    // 既存イベントを一度クリア（リサイズ対応したい時のため）
    button.replaceWith(button.cloneNode(true));
  });

  document.querySelectorAll('.is-pulldown-btn').forEach(button => {
    const subMenu = button.nextElementSibling;

    const addActive = () => {
      button.classList.add('is-active');
      if(subMenu) subMenu.classList.add('is-active');
    };

    const removeActive = () => {
      button.classList.remove('is-active');
      if(subMenu) subMenu.classList.remove('is-active');
    };

    button.addEventListener('mouseenter', addActive);
    button.addEventListener('mouseleave', removeActive);

    if(subMenu){
      subMenu.addEventListener('mouseenter', addActive);
      subMenu.addEventListener('mouseleave', removeActive);
    }
  });
}

function removeHoverMenu() {
  // 950px未満では is-active を消しておく
  document.querySelectorAll('.is-pulldown-btn').forEach(button => {
    const subMenu = button.nextElementSibling;
    button.classList.remove('is-active');
    if(subMenu) subMenu.classList.remove('is-active');

    // hover用イベント削除の代わりに要素ごとクローンして全イベント消去
    button.replaceWith(button.cloneNode(true));
  });
}

// 最初の実行
if (mq.matches) {
  setupHoverMenu();
}

// 画面幅が変わったら切り替える（レスポンシブ対応）
mq.addEventListener('change', (e) => {
  if (e.matches) {
    setupHoverMenu();
  } else {
    removeHoverMenu();
  }
});


/*-------------------------------------------------------------------------------
  sp global nav
--------------------------------------------------------------------------------*/

// .is-pulldown-single
document.addEventListener("DOMContentLoaded", () => {
  const isMobile = () => window.innerWidth <= 950;

  // .is-pulldown-single タップで直下の .hd-sub-unit を開閉
  document.querySelectorAll('.is-pulldown-single').forEach(button => {
    button.addEventListener('click', (e) => {
      if (!isMobile()) return; // 950px以上なら無効
      e.preventDefault();
      const subUnit = button.nextElementSibling; // 直下の.hd-sub-unit
      if (!subUnit) return;

      if (subUnit.style.maxHeight) {
        subUnit.style.maxHeight = null; // 閉じる
      } else {
        subUnit.style.maxHeight = subUnit.scrollHeight + "px"; // 開く
      }
    });
  });

  // リサイズ時にmaxHeightリセット
  window.addEventListener('resize', () => {
    if (!isMobile()) {
      document.querySelectorAll('.hd-sub-unit, .hd-sub-nav').forEach(el => {
        el.style.maxHeight = null;
      });
    }
  });

});

// .is-pulldown-multi
document.addEventListener('DOMContentLoaded', () => {
  const breakpoint = 950;
  const animMs = 400;

  const isMobile = () => window.innerWidth <= breakpoint;

  // ▼ .hd-sub-nav（子）を開く
  function openInner(el) {
    if (!el || el.classList.contains('is-open')) return;

    el.style.display = "block";         // まず表示
    el.style.overflow = "hidden";
    el.style.height = "0px";

    const h = el.scrollHeight;          // 開く高さを取得

    void el.offsetHeight;               // reflow

    el.classList.add("is-open");
    el.style.transition = `height ${animMs}ms ease`;
    el.style.height = h + "px";

    // 完了後に height:auto に戻して可変コンテンツに対応
    setTimeout(() => {
      el.style.height = "auto";
      el.style.transition = "";
    }, animMs + 20);
  }

  // ▼ .hd-sub-nav（子）を閉じる
  function closeInner(el) {
    if (!el || !el.classList.contains('is-open')) return;

    const h = el.scrollHeight;
    el.style.height = h + "px";

    void el.offsetHeight;

    el.style.transition = `height ${animMs}ms ease`;
    el.style.height = "0px";

    setTimeout(() => {
      el.classList.remove("is-open");
      el.style.transition = "";
      el.style.display = "none";
      el.style.height = "";
    }, animMs + 20);
  }

  // ▼ 親 .hd-sub-unit の max-height を再計算
  function recalcParent(parent) {
    if (!parent || !parent.classList.contains("is-open")) return;
    parent.style.maxHeight = parent.scrollHeight + "px";
  }

  // ▼ 親を開閉（.is-pulldown-multi）
  function toggleParent(unit) {
    if (!unit) return;

    if (unit.classList.contains("is-open")) {
      unit.querySelectorAll(".hd-sub-multi-nav.is-open").forEach(n => closeInner(n));
      unit.style.maxHeight = "0px";
      unit.classList.remove("is-open");
      return;
    }

    unit.classList.add("is-open");
    unit.style.maxHeight = unit.scrollHeight + "px";
  }

  // ▼ 初期化
  function init() {
    if (!isMobile()) return;

    // 1階層：.is-pulldown-multi → .hd-sub-unit
    document.querySelectorAll(".is-pulldown-multi").forEach(btn => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        const unit = this.nextElementSibling;
        toggleParent(unit);
      });
    });

    // 2階層：.hd-sub-nav-cat-txt → .hd-sub-nav
    document.querySelectorAll(".hd-sub-nav-cat-txt").forEach(cat => {
      cat.addEventListener("click", function (e) {
        e.preventDefault();
        const nav = this.nextElementSibling;
        const parent = this.closest(".hd-sub-unit");

        if (nav.classList.contains("is-open")) {
          closeInner(nav);
          setTimeout(() => recalcParent(parent), animMs + 30);
        } else {
          openInner(nav);
          setTimeout(() => recalcParent(parent), animMs + 30);
        }
      });
    });
  }

  init();
});

/*-------------------------------------------------------------------------------
  hamburger nav
--------------------------------------------------------------------------------*/
document.querySelectorAll('.trigger-btn').forEach(function(button) {
  button.addEventListener('click', function(event) {
    event.preventDefault();
    button.classList.toggle('is-active');
    document.querySelector('.hd-block').classList.toggle('is-active');
  });
});


/*-------------------------------------------------------------------------------
  anchor link
--------------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const headerHeight = document.querySelector("header").offsetHeight + 20;

  // スムーススクロール関数（共通化）
  function smoothScrollTo(targetElement) {
    if (!targetElement) return;

    const offsetTop =
      targetElement.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight;

    window.scrollTo({
      top: offsetTop,
      behavior: "smooth",
    });
  }

  // 別ページから来たとき
  if (location.hash) {
    const target = document.querySelector(location.hash);
    if (target) {
      setTimeout(() => {
        smoothScrollTo(target);
      }, 100);
    }
  }

  // ▼ ページ内リンククリック
  document.querySelectorAll("a[href*='#']").forEach((link) => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      const [path, hash] = href.split("#");

      if (!hash) return; // ハッシュなし → 何もしない

      // 絶対URLと相対URLの両方に対応
      let linkPathname = "";
      if (path) {
        try {
          // 絶対URLの場合はURLオブジェクトでpathnameを取得
          const url = new URL(path, location.origin);
          linkPathname = url.pathname.replace(/\/$/, "");
        } catch {
          // 相対パスの場合はそのまま使用
          linkPathname = path.replace(/\/$/, "");
        }
      } else {
        // パスが空の場合は現在のページ
        linkPathname = location.pathname.replace(/\/$/, "");
      }

      const currentPathname = location.pathname.replace(/\/$/, "");

      // リンク先ページが現在と同じなら「ページ内リンク」
      const isSamePage = linkPathname === currentPathname;

      if (!isSamePage) {
        // → 別ページに遷移
        return;
      }

      // ▼ ページ内リンクとして処理
      e.preventDefault();

      const target = document.querySelector(`#${hash}`);
      if (!target) return;

      smoothScrollTo(target);
      history.pushState(null, null, `#${hash}`);
    });
  });

  // ▼ .form-cmn-btn と .back のクリック時もスムーススクロール
  document.addEventListener('click', function(e) {
    // .form-cmn-btn（確認画面へ） - ただし.submitがない場合のみ
    const formBtn = e.target.closest('.form-cmn-btn');
    if (formBtn && !formBtn.closest('.submit')) {
      setTimeout(() => {
        const formConfirm = document.querySelector('#form-confirm');
        if (formConfirm) {
          smoothScrollTo(formConfirm);
        }
      }, 100);
    }

    // .back（入力画面へ戻る）
    if (e.target.closest('.back')) {
      setTimeout(() => {
        const formInput = document.querySelector('#form-input');
        if (formInput) {
          smoothScrollTo(formInput);
        }
      }, 100);
    }
  });
});


/*-------------------------------------------------------------------------------
  sticky side nav
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('single-medical') || document.body.classList.contains('about') || document.body.classList.contains('single-division') || document.body.classList.contains('nursing-recruit') || document.body.classList.contains('rehabilitation-recruit')) {

    var winW = window.innerWidth;
    var spW = 768;

    // PCのみ有効
    if (winW >= spW) {

      var pinStart = "top-=150vw";
      var pinEnd = "top bottom";
      var triggerStart = "top center-=200vh";
      var triggerEnd = "bottom center-=200vh";

      ScrollTrigger.create({
        pin: true,
        trigger: ".cmn-side-nav",
        start: pinStart,
        endTrigger: ".footer",
        end: pinEnd,
        // markers: true,
      });

      // ボタンに対応するセクションごとに設定（動的検出）
      document.querySelectorAll('[id^="item-"]').forEach(section => {
        const id = section.id;
        const num = id.replace('item-', '');
        const catBtn = `.js-btn-${num}`;

        ScrollTrigger.create({
          trigger: `#${id}`,
          start: triggerStart,
          end: triggerEnd,
          toggleClass: {
            targets: catBtn,
            className: 'is-current'
          }
        });
      });
    }
  }
});


/*-------------------------------------------------------------------------------
  scroll hint
--------------------------------------------------------------------------------*/
window.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 1480) {
    new ScrollHint('.js-scrollable', {
      scrollHintIconAppendClass: 'scroll-hint-icon-white',
      i18n: {
        scrollable: "スクロールできます"
      }
    });
  }
});


/*-------------------------------------------------------------------------------
  gradation background
--------------------------------------------------------------------------------*/
// Create your instance
const gradient = new Gradient()
// Call `initGradient` with the selector to your canvas
gradient.initGradient('#gradient-canvas')

/*-------------------------------------------------------------------------------
  chart
--------------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {

  // 数値を日本語表記に変換する関数（キリの良い万単位のみ表示）
  function formatJapaneseNumber(value) {
    if (value >= 10000) {
      // 万単位で割り切れる場合のみ表示（40000→4万、45000→非表示）
      if (value % 10000 === 0) {
        const man = Math.floor(value / 10000);
        return man + '万';
      } else {
        return '';
      }
    } else if (value >= 1000) {
      return '';
    } else if (value >= 100) {
      return Math.floor(value / 100) + '百';
    }
    return value;
  }

  // 延入院患者数 / 平均入院患者数
  const hospitalchart = document.getElementById('hospitalChart');

  new Chart(hospitalchart, {
    type: 'bar',
    data: {
      labels: chartData.years,
      datasets: [
        {
          label: '延入院患者数',
          data: chartData.total,
          backgroundColor: '#a0dfffab',
          yAxisID: 'y1',
          // barThickness: 20,
        },
        {
          label: '平均入院患者数',
          data: chartData.avg,
          backgroundColor: 'rgba(255, 131, 158, 0.7)',
          yAxisID: 'y2',
          // barThickness: 20,
        }
      ]
    },
    options: {
      responsive: true,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: '#2A2A2A',
          font: {
            size: window.innerWidth <= 768 ? 10 : 14,
          },
          formatter: function(value, hospitalchart) {
            // 右軸(平均)には「人」を付けたくない場合の条件分岐も可能
            return value + '人';
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            color: '#2A2A2A',
            font: {
              size: 15,
            }
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 13 : 15,
            }
          }
        },
        y1: {
          type: 'linear',
          position: 'left',
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 13 : 15,
            },
            callback: function(value) {
              return formatJapaneseNumber(value);
            }
          }
        },
        y2: {
          type: 'linear',
          position: 'right',
          grid: { drawOnChartArea: false },
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 13 : 15,
            },
            callback: function(value) {
              return value;
            }
          }
        },
      },
    },
    plugins: [ChartDataLabels]
  });

  // 平均在院日数 / 病床稼働率
  const labels = stayOccChartData.map(item => item.year);
  const stayDays = stayOccChartData.map(item => item.stay_days);
  const occupancy = stayOccChartData.map(item => item.occupancy);

  const stayoccChart = document.getElementById("stayOccChart");

  new Chart(stayoccChart, {
    type: "bar",
    data: {
      labels: labels,
      datasets: [
        {
          type: "bar",
          label: "平均在院日数",
          data: stayDays,
          yAxisID: "yDays",
          backgroundColor: "#a0dfffab",
          borderWidth: 0,
          barPercentage: 0.5,
        },
        {
          type: "line",
          label: "病床稼働率「一般」",
          data: occupancy,
          yAxisID: "yOcc",
          borderColor: "rgba(255, 131, 158, 0.7)",
          backgroundColor: "rgba(255, 131, 158, 1)",
          borderWidth: 2,
          pointRadius: 5,
        }
      ]
    },

    options: {
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#2A2A2A',
            font: {
              size: 15,
            }
          }
        },
        datalabels: {
          anchor: "top",
          align: "end",
          color: '#2A2A2A',
          font: {
            size: window.innerWidth <= 768 ? 11 : 14,
          },
          formatter: function(value, stayoccChart) {
            return stayoccChart.dataset.yAxisID === "yDays"
              ? value + "日"
              : value + "%";
          }
        },
      },

      scales: {
        x: {
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 13 : 15,
            }
          }
        },
        yDays: {
          position: "left",
          min: 0,
          max: 40,
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 13 : 15,
            },
            callback: (v) => v + "日",
          }
        },
        yOcc: {
          position: "right",
          min: 60,
          max: 90,
          grid: { drawOnChartArea: false },
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 13 : 15,
            },
            callback: (v) => v + "%",
          }
        }
      }
    },
    maintainAspectRatio: false,
    plugins: [ChartDataLabels]
  });

  // 延外来患者数 / 平均外来患者数（1日あたり）
  const outpatientchart = document.getElementById('outpatientChart');
  if (outpatientchart && typeof outpatientChartData !== 'undefined') {
    new Chart(outpatientchart, {
      type: 'bar',
      data: {
        labels: outpatientChartData.years,
        datasets: [
          {
            label: '延外来患者数',
            data: outpatientChartData.total,
            backgroundColor: '#a0dfffab',
            yAxisID: 'y1',
          },
          {
            label: '平均外来患者数（1日あたり）',
            data: outpatientChartData.avg,
            backgroundColor: 'rgba(255, 131, 158, 0.7)',
            yAxisID: 'y2',
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: window.innerWidth <= 768 ? 25 : 30,
            bottom: 10,
            left: 5,
            right: 5
          }
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 10 : 14,
            },
            formatter: function(value) {
              return value + '人';
            }
          },
          legend: {
            position: 'bottom',
            labels: {
              color: '#2A2A2A',
              font: {
                size: 15,
              }
            }
          }
        },
        scales: {
          x: {
            ticks: {
              color: '#2A2A2A',
              font: {
                size: window.innerWidth <= 768 ? 13 : 15,
              }
            }
          },
          y1: {
            type: 'linear',
            position: 'left',
            ticks: {
              color: '#2A2A2A',
              font: {
                size: window.innerWidth <= 768 ? 13 : 15,
              },
              callback: function(value) {
                return formatJapaneseNumber(value);
              }
            }
          },
          y2: {
            type: 'linear',
            position: 'right',
            grid: { drawOnChartArea: false },
            ticks: {
              color: '#2A2A2A',
              font: {
                size: window.innerWidth <= 768 ? 13 : 15,
              },
              callback: function(value) {
                return value;
              }
            }
          },
        },
      },
      plugins: [ChartDataLabels]
    });
  }

});

// 回復期リハビリテーション統計グラフ
const convCharts = document.querySelectorAll('.conv-chart');
convCharts.forEach(function(canvas) {
  const labels = JSON.parse(canvas.getAttribute('data-labels'));
  const values = JSON.parse(canvas.getAttribute('data-values'));
  const colors = JSON.parse(canvas.getAttribute('data-colors'));

  new Chart(canvas, {
    type: 'pie',
    data: {
      labels: labels,
      datasets: [{
        data: values,
        backgroundColor: colors,
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false
        },
        datalabels: {
          color: '#2A2A2A',
          font: {
            size: window.innerWidth <= 768 ? 13 : 16,
          },
          formatter: function(value, context) {
            // グレー背景（残りの部分）は数値を表示しない
            const color = context.dataset.backgroundColor[context.dataIndex];
            if (color === '#D9D9D9') {
              return '';
            }
            const label = context.chart.data.labels[context.dataIndex];
            return label + '\n' + value + '%';
          }
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              return context.label + ': ' + context.parsed + '%';
            }
          }
        }
      }
    },
    plugins: [ChartDataLabels]
  });
});

// 回復期リハビリテーション棒グラフ（FIM用）
const convBarCharts = document.querySelectorAll('.conv-bar-chart:not(.is-single)');
convBarCharts.forEach(function(canvas) {
  const labels = JSON.parse(canvas.getAttribute('data-labels'));
  const datasets = JSON.parse(canvas.getAttribute('data-datasets'));

  new Chart(canvas, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: datasets
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: window.innerWidth <= 768 ? 25 : 30,
          bottom: 10,
          left: 5,
          right: 5
        }
      },
      plugins: {
        legend: {
          display: false
        },
        datalabels: {
          anchor: 'end',
          align: 'bottom',
          color: '#2A2A2A',
          font: {
            size: window.innerWidth <= 768 ? 13 : 15,
          },
          formatter: function(value, context) {
            const label = context.dataset.label; // "入院" or "退院"
            return label + '\n' + value + '点';
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 12 : 15,
            }
          }
        },
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: 'FIM-M（点）',
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 13 : 15,
            }
          },
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 12 : 15,
            }
          }
        }
      }
    },
    plugins: [ChartDataLabels]
  });
});

// 在院日数 棒グラフ (is-single)
document.querySelectorAll('.conv-bar-chart.is-single').forEach(function(canvas) {
  const labels = JSON.parse(canvas.dataset.labels);
  const datasets = JSON.parse(canvas.dataset.datasets);

  // グラフIDで単位を判別
  let unit = '';
  if (canvas.id === 'stayDaysChart') {
    unit = '日';
  } else if (canvas.id === 'performanceIndexChart') {
    unit = '点';
  }

  new Chart(canvas.getContext('2d'), {
    type: 'bar',
    data: {
      labels: labels,
      datasets: datasets
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 40
        }
      },
      plugins: {
        legend: {
          display: false
        },
        datalabels: {
          anchor: 'end',
          align: 'bottom',
          color: '#2A2A2A',
          font: {
            size: window.innerWidth <= 768 ? 14 : 16,
          },
          formatter: function(value) {
            return value + unit;
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 12 : 15,
            }
          }
        },
        y: {
          beginAtZero: true,
          title: {
            display: false
          },
          ticks: {
            color: '#2A2A2A',
            font: {
              size: window.innerWidth <= 768 ? 12 : 15,
            }
          }
        }
      }
    },
    plugins: [ChartDataLabels]
  });
});

//年代別ドーナツグラフ
document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('ageChart');

  if (!canvas) return;

  // data属性から値を取得
  const labels = JSON.parse(canvas.dataset.chartLabels || '[]');
  const values = JSON.parse(canvas.dataset.chartValues || '[]');
  const colors = JSON.parse(canvas.dataset.chartColors || '[]');

  if (labels.length === 0 || values.length === 0) return;

  // 合計値を計算してパーセンテージを算出
  const total = values.reduce((sum, val) => sum + val, 0);

  // Chart.jsでドーナツグラフを作成
  new Chart(canvas, {
    type: 'doughnut',
    data: {
      labels: labels,
      datasets: [{
        data: values,
        backgroundColor: colors,
        borderWidth: 0,
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      cutout: '30%',  // 中央の空白サイズ（小さいほどドーナツの幅が広くなる。デフォルト50%）
      plugins: {
        legend: {
          display: false  // 凡例を非表示
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              const label = context.label || '';
              const value = context.parsed || 0;
              const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
              return `${label}: ${percentage}%`;
            }
          }
        },
        datalabels: {
          color: '#2A2A2A',
          font: {
            weight: 'bold',
            size: 14
          },
          formatter: function(value, context) {
            const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
            const label = context.chart.data.labels[context.dataIndex];
            return `${label}\n${percentage}%`;
          }
        }
      }
    },
    plugins: [ChartDataLabels]
  });
});


/*-------------------------------------------------------------------------------
  day tab switching
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.day-tab-btn');
  const tabContents = document.querySelectorAll('.day-tab-block');

  if (tabButtons.length === 0 || tabContents.length === 0) return;

  // 初期状態：最初のタブを表示
  tabContents[0].classList.add('is-active');

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      // 全てのボタンとコンテンツから is-current/is-active を削除
      tabButtons.forEach(btn => btn.classList.remove('is-current'));
      tabContents.forEach(content => content.classList.remove('is-active'));

      // クリックされたボタンと対応するコンテンツに is-current/is-active を追加
      button.classList.add('is-current');
      tabContents[index].classList.add('is-active');
    });
  });
});

/*-------------------------------------------------------------------------------
  recruit daily schedule tab switching
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.recruit-daily-schedule-tab-btn');
  const tabContents = document.querySelectorAll('.recruit-daily-schedule-tab-block');

  if (tabButtons.length === 0 || tabContents.length === 0) return;

  // 初期状態：最初のタブを表示
  tabButtons[0].classList.add('is-current');
  tabContents[0].classList.add('is-active');

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      // 全てのボタンとコンテンツから is-current/is-active を削除
      tabButtons.forEach(btn => btn.classList.remove('is-current'));
      tabContents.forEach(content => content.classList.remove('is-active'));

      // クリックされたボタンと対応するコンテンツに is-current/is-active を追加
      button.classList.add('is-current');
      tabContents[index].classList.add('is-active');
    });
  });
});


/*-------------------------------------------------------------------------------
  format number with unit (数値と記号を分離してspanで囲む)
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.data-cmn-txt');

  elements.forEach(element => {
    const text = element.textContent.trim();

    // 数値以外の文字（記号や文字）を全てspanで囲む
    // 例: "26%" → "26<span>%</span>"
    // 例: "38歳10カ月" → "38<span>歳</span>10<span>カ月</span>"
    const formattedText = text.replace(/([^\d.]+)/g, '<span>$1</span>');

    // 変更があった場合のみ適用
    if (formattedText !== text && formattedText.includes('<span>')) {
      element.innerHTML = formattedText;
    }
  });
});


/*-------------------------------------------------------------------------------
  side nav toggle (mobile)
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const sideNav = document.querySelector('.cmn-side-nav');
  if (!sideNav || window.innerWidth > 768) return;

  // single-medicalページでは実行しない
  if (document.body.classList.contains('single-medical')) return;

  // トグルボタンを動的に生成
  const toggleBtn = document.createElement('button');
  toggleBtn.className = 'side-nav-toggle';
  toggleBtn.textContent = '目次をすべて見る';

  // カラークラスを継承
  const navBtn = sideNav.querySelector('.cmn-nav-btn');
  if (navBtn && navBtn.classList.contains('is-nursing-color')) {
    toggleBtn.classList.add('is-nursing-color');
  } else if (navBtn && navBtn.classList.contains('is-rehab-color')) {
    toggleBtn.classList.add('is-rehab-color');
  }

  // サイドナビの後に挿入
  sideNav.parentNode.insertBefore(toggleBtn, sideNav.nextSibling);

  // 初期状態: 折りたたみ
  const listItems = sideNav.querySelectorAll('li');
  const collapsedHeight = listItems.length > 0 ? Math.min(4, listItems.length) * 45 : 180; // li 4つ分 (45px×4)

  sideNav.style.maxHeight = `${collapsedHeight}px`;
  sideNav.classList.add('is-collapsed');

  // トグルボタンのクリックイベント
  toggleBtn.addEventListener('click', () => {
    if (sideNav.classList.contains('is-collapsed')) {
      // 展開
      const fullHeight = sideNav.scrollHeight;
      sideNav.style.maxHeight = `${fullHeight}px`;
      sideNav.classList.remove('is-collapsed');
      toggleBtn.textContent = '目次を折りたたむ';
    } else {
      // 折りたたみ
      sideNav.style.maxHeight = `${collapsedHeight}px`;
      sideNav.classList.add('is-collapsed');
      toggleBtn.textContent = '目次をすべて見る';
    }
  });

  // リサイズ時にボタンを非表示/表示
  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) {
      toggleBtn.style.display = 'none';
      sideNav.classList.remove('is-collapsed');
    } else {
      toggleBtn.style.display = 'flex';
    }
  });
});

/*-------------------------------------------------------------------------------
  TOP Validation
--------------------------------------------------------------------------------*/
if (document.body.classList.contains('entry') ) {
  topValidation();
}

/*-------------------------------------------------------------------------------
  MV Swiper初期化
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const swiperElement = document.querySelector(".swiper");
  if (!swiperElement) return;

  // スライド数を確認
  const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;

  const swiper = new Swiper(".swiper", {
    loop: slideCount >= 3, // 3枚以上の場合のみループを有効化
    effect: "fade", // フェード切り替え
    fadeEffect: {
      crossFade: true
    },
    // 自動再生
    autoplay: slideCount > 1 ? {
      delay: 5000, // 5秒後に次のスライドへ
      disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
    } : false,
    speed: 2000, // 2秒かけてフェード
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

/*-------------------------------------------------------------------------------
  News Tab Switching
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const tabItems = document.querySelectorAll('.news-tab-item');
  const newsLists = document.querySelectorAll('.news-list');

  if (tabItems.length === 0 || newsLists.length === 0) return;

  tabItems.forEach(tab => {
    tab.addEventListener('click', () => {
      const category = tab.getAttribute('data-category');

      // タブのアクティブ状態を切り替え
      tabItems.forEach(item => item.classList.remove('is-active'));
      tab.classList.add('is-active');

      // コンテンツの表示を切り替え
      newsLists.forEach(list => {
        if (list.getAttribute('data-content') === category) {
          list.classList.add('is-active');
        } else {
          list.classList.remove('is-active');
        }
      });
    });
  });
});

/*-------------------------------------------------------------------------------
  Recruit MV Animation
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // recruit-mvセクションが存在しない場合は処理を終了
  const recruitMvSec = document.querySelector('.recruit-mv-sec');
  if (!recruitMvSec) return;

  const bgTxt = document.querySelector('.recruit-mv-bg-txt');
  const mvImg = document.querySelector('.recruit-mv-img');
  const mvCopies = document.querySelectorAll('.recruit-mv-copy');
  const mvName = document.querySelector('.recruit-mv-name');

  // GSAPタイムラインを作成
  const tl = gsap.timeline({
    defaults: {
      ease: 'power2.out'
    }
  });

  // ①.recruit-mv-bg-txt→ふわっと表示される
  tl.fromTo(bgTxt,
    {
      opacity: 0,
      y: 30
    },
    {
      opacity: 1,
      y: 0,
      duration: 1
    },
    0.3 // 開始タイミング
  );

  // ②.recruit-mv-img→ふわっと表示される
  tl.fromTo(mvImg,
    {
      opacity: 0,
      y: 30
    },
    {
      opacity: 1,
      y: 0,
      duration: 1
    },
    0.5 // 開始タイミング
  );

  // ③④.recruit-mv-copy（1個目と2個目）→オビが左から右にスライドイン
  mvCopies.forEach((copy, index) => {
    tl.fromTo(copy,
      {
        clipPath: 'inset(0 100% 0 0)'
      },
      {
        clipPath: 'inset(0 0% 0 0)',
        duration: 0.9,
        ease: 'power2.inOut'
      },
      0.8 + (index * 0.2) // 各コピーを少しずつずらす
    );
  });

  // ⑤.recruit-mv-name→オビが左から右にスライドイン
  tl.fromTo(mvName,
    {
      clipPath: 'inset(0 100% 0 0)'
    },
    {
      clipPath: 'inset(0 0% 0 0)',
      duration: 0.9,
      ease: 'power2.inOut'
    },
    1.2 // 開始タイミング
  );

  // Recruit Message Pictures Scroll Animation
  // .recruit-message-pictures部分にスクロールされたら、.recruit-message-imgを順番に表示
  const messageImgs = document.querySelectorAll('.recruit-message-img');

  if (messageImgs.length > 0) {
    gsap.fromTo(messageImgs,
      {
        opacity: 0,
        y: 40
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.9,
        stagger: 0.3, // 各画像を0.2秒ずつずらして表示
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.recruit-message-pictures',
          start: 'top 80%', // ビューポートの80%の位置に要素のtopが来たら開始
          toggleActions: 'play none none none' // 一度だけ再生
        }
      }
    );
  }
});